import React, { memo } from 'react'
import { CopyToClipboardBase } from 'root/src/client/web/base/CopyToClipboardBase'
import toast from 'react-hot-toast'

const CopyToClipboardAlerted = memo(({ url, children, className }) => {
	const onCopied = async () => {
		toast.success('Copied to clipboard!')
	}

	return (
		<div className={className}>
			<CopyToClipboardBase
				text={url}
				onCopied={onCopied}
			>
				{children}
			</CopyToClipboardBase>
		</div>
	)
})

export default CopyToClipboardAlerted
